module.exports = __webpack_public_path__ + "static/media/01A.680e0e44.png";